import { render, staticRenderFns } from "./DeanToolbar.vue?vue&type=template&id=8a9c8d9e"
import script from "./DeanToolbar.vue?vue&type=script&lang=js"
export * from "./DeanToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports